import Layout from '../../layout/default';
import { isMobile, isTablet } from 'react-device-detect';
import Select from 'react-select';
import { useEffect, useState, useMemo } from 'react';
import { getAvailableFacilitiesService, getPhonesDataService } from '../../services/phones-module';
import { useAuth } from '../../container/authContext';
import cx from 'classnames';
import { useParams } from 'react-router-dom';
import './styles.scss';
import _ from 'lodash';

const PhonesModule = () => {
  const user = useAuth();
  const { companyId } = useParams();
  const [facilityOptions, setFacilityOptions] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [search, setSearch] = useState('');
  const [users, setUsers] = useState([]);

  useEffect(() => {
    try {
      getAvailableFacilitiesService({ company_id: companyId }).then((res) => {
        setFacilityOptions(
          res.data.map((facility) => ({
            label: facility.name,
            value: facility.id,
          })),
        );
      });
    } catch (e) {
      console.log(e);
    }
  }, [user]);

  useEffect(() => {
    if (selectedFacility?.value) {
      try {
        getPhonesDataService({ facility_id: selectedFacility.value, search_query: search })
          .then((res) => {
            setUsers(res.data);
          })
          .catch((e) => {
            console.log(e);
          });
      } catch (e) {
        console.log(e);
      }
    }
  }, [selectedFacility, search]);

  const usersChunked = useMemo(() => {
    return isMobile ? [users] : _.chunk(users, 23);
  }, [users]);

  return (
    <Layout
      title="Phone book"
      className={cx('phone-module-page-layout', {
        isTablet,
        isMobile,
      })}
      breadcrumbs={[
        {
          name: 'Phone book',
        },
        ...(selectedFacility?.label ? [{ name: selectedFacility?.label }] : []),
      ]}
    >
      <div className="page-wrapper">
        <div className="page-header">
          <div className="page-header-left d-flex">
            <div className="form-item form-item-select form-control-item-settings facility-select">
              <label className="form-label">Facility</label>
              <Select
                isSearchable={false}
                options={facilityOptions}
                className="form-control-select"
                classNamePrefix="react-select"
                value={selectedFacility}
                onChange={(e) => setSelectedFacility(e)}
                placeholder="Select Facility"
              />
            </div>
            <div className="library-filter-search form-control-item">
              <input type="text" className="form-control" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search" />
              <i className="icon-search"></i>
            </div>
          </div>
        </div>

        <div className="page-content">
          {selectedFacility?.value ? (
            users?.length > 0 ? (
              <div className="user-tables-wrapper">
                {usersChunked.map((usersChunk, index) => (
                  <div className="table-responsive table-default table-full" key={index}>
                    <div className="table-wrapper">
                      <div className="table">
                        <div className="tr">
                          <div className="th last-name-col">Last Name</div>
                          <div className="th first-name-col">Name</div>
                          <div className="th phone-col">Phone Number</div>
                        </div>

                        {usersChunk.map((item) => (
                          <div className="tr" key={item.id}>
                            <div className="td last-name-col">{item.last_name}</div>
                            <div className="td first-name-col">{item.first_name}</div>
                            <div className="td phone-col">{item.phone}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="empty">
                <p className="empty-title text-center">No users found</p>
              </div>
            )
          ) : (
            <div className="empty">
              <p className="empty-title text-center">To see the information select the facility</p>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default PhonesModule;
